// eslint-disable-next-line import/no-default-export
export default {
  methods: {
    close: function () {
      if (this.$refs.portal) {
        this.$refs.portal.close()
      }
      if (this.clear) {
        this.clear()
      }
    },
    open: function (cb) {
      if (this.$refs.portal) {
        this.$refs.portal.open()
      }
      if (this.clear) {
        this.clear()
      }
      // 这里并没有调用 cb
    }
  }
}
